<div [ngClass]="{'page-dark': isDarkMode.checked, 'page-light': !isDarkMode.checked}">
    <div [ngClass]="{'header': true, 'header-dark': isDarkMode.checked, 'header-light': !isDarkMode.checked}">
        <h1 [ngClass]="{'title': true, 'title-dark': isDarkMode.checked, 'title-light': !isDarkMode.checked}">Create Work Order</h1>
        <div (click)="submit()" class="header-button">
            <fa-icon [icon]="submitButton" size="xl" style="display:block;margin:auto;"></fa-icon>
        </div>
        <div (click)="goBack()" class="header-button">
            <fa-icon [icon]="goBackButton" size="xl" style="margin:auto;text-align:center;width:100%;background-color:brown;" ></fa-icon>
        </div>
        <input #isDarkMode [hidden]="true" type="checkbox" [checked]="false">
        <div (click)="isDarkMode.checked = !isDarkMode.checked" class="header-button" id="dark-mode-button">
            <fa-icon [icon]="isDarkMode.checked ? lightModeButton : darkModeButton" size="xl"></fa-icon>
        </div>

    </div>
    <div class="body">
        <dialog #loadInfoDialog style="position:absolute;top:50%" [ngClass]="{'dialog-dark': isDarkMode.checked}">
            <form [formGroup]="load_form" >
                <input type="text" formControlName="load_details" size="80" placeholder="Load Details">
                <br><br>
                <input type="text" formControlName="load_special_info" size="80" placeholder="Special Info">
            </form>
            <br>
            <button (click)="loadInfoDialog.close()" style="margin:auto">Save and Close</button>
        </dialog>
        <dialog #opsNotationDialog [ngClass]="{'dialog-dark': isDarkMode.checked}">
            <form [formGroup]="operations_form">
                <input type="text" formControlName="operations_notation" size="100" placeholder="Operations Notation">
            </form>
            <br>
            <button (click)="opsNotationDialog.close()">Save and Close</button>
        </dialog>
        <div class="validation-messages">
            <!--
            <div *ngIf="requiredInputs.length > 0">
                <b>Required Information: </b>
                <span *ngFor="let message of requiredInputs; let i = index">
                    {{message}}{{i < requiredInputs.length-1 ? ', ' : ''}}
                </span>
            </div>
            <div *ngIf="invalidInputs.length > 0">
                <b>Invalid Information: </b>
                <span *ngFor="let message of invalidInputs; let i = index">
                    {{message}}{{i < invalidInputs.length-1 ? ', ' : ''}}
                </span>
            </div>
            -->
        </div>
        <div class="cards">
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}" [id]="isDarkMode.checked ? 'customer-card-dark': 'customer-card-light'">
                <div class="card-header">
                    <h2>Customer Information</h2>
                </div>
                <div class="card-body">
                    <div class="card-body-section">
                        <h4 [ngClass]="{'card-body-section-title-dark': isDarkMode.checked, 'card-body-section-title-light': !isDarkMode.checked}">Company</h4>
                        <form [formGroup]="customer_form">
                            <div class="form-field">
                                <label for="customer-name">Name</label>
                                <input #customer_name list="customer_list" name="customer-name" type="text" formControlName="customer_company_name" (keyup)="autofillContact('customer',customer_name.value)">
                                <datalist id="customer_list">
                                    <ng-container>
                                        
                                    </ng-container>
                                </datalist>
                            </div>
                            <div class="form-field">
                                <label for="customer-address">Address</label>
                                <input name="customer-address" type="text" placeholder="Select company name first" formControlName="customer_company_address">
                            </div>
                            <div class="form-field">
                                <label for="customer-consignee-agreement">Consignee Agreement Required</label>
                                <input name="customer-consignee-agreement" type="checkbox" [ngClass]="{'dark': isDarkMode.checked}">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Notification Requirements</h4>
                        <form [formGroup]="customer_form">
                            <div class="form-field">
                                <label for="customer-notif-at-pickup">At Pickup</label>
                                <input name="customer-notif-at-pickup" type="checkbox" formControlName="customer_at_pickup_notification">
                            </div>
                            <div class="form-field">
                                <label for="customer-notif-delayed-pickup">Delayed Pickup</label>
                                <input name="customer-notif-delayed-pickup" type="checkbox" formControlName="customer_delayed_pickup_notification">
                            </div>
                            <div class="form-field">
                                <label for="customer-notif-at-delivery">At Delivery</label>
                                <input name="customer-notif-at-delivery" type="checkbox" formControlName="customer_at_delivery_notification">
                            </div>
                            <div class="form-field">
                                <label for="customer-notif-delayed-delivery">Delayed Delivery</label>
                                <input name="customer-notif-delayed-delivery" type="checkbox" formControlName="customer_delayed_delivery_notification">
                            </div>
                            <div class="form-field">
                                <label for="customer-notif-assessorials-incured">Assessorials Incured</label>
                                <input name="customer-notif-assessorials-incured" type="checkbox" formControlName="customer_assessorials_incurred_notification">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Document Requirements</h4>
                        <form [formGroup]="customer_form">
                            <div class="form-field">
                                <label for="customer-shipping-bol">Shipping BOL</label>
                                <input name="customer-shipping-bol" type="checkbox" formControlName="customer_shipping_bol">
                            </div>
                            <div class="form-field">
                                <label for="customer-invoice-bol">Invoice BOL</label>
                                <input name="customer-invoice-bol" type="checkbox" formControlName="customer_invoice_bol">
                            </div>
                            <div class="form-field">
                                <label for="customer-invoice-pod">Invoice POD</label>
                                <input name="customer-invoice-pod" type="checkbox" formControlName="customer_invoice_pod_required">
                            </div>
                            <div class="form-field">
                                <label for="customer-po-number">PO Number</label>
                                <input name="customer-po-number" type="checkbox" formControlName="customer_invoice_po_required">
                            </div>
                            <div class="form-field">
                                <label for="customer-quote-invoice">Rate Quote Invoice</label>
                                <input name="customer-quote-invoice" type="checkbox" formControlName="customer_rate_quote">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}" [id]="isDarkMode.checked ? 'shipper-card-dark' : 'shipper-card-light'">
                <div class="card-header">
                    <h2>Shipper</h2>
                </div>
                <div class="card-body">
                    <form [formGroup]="shipper_form">
                        <div class="card-body-section">
                            <h4 class="card-body-section-title">Company</h4>
                            <div class="form-field">
                                <label for="shipper-name">Name</label>
                                <input name="shipper-name" type="text" formControlName="shipper_company_name">
                            </div>
                            <div class="form-field">
                                <label for="shipper-address">Address</label>
                                <input name="shipper-address" type="text" placeholder="Select company name first" formControlName="shipper_company_address">
                            </div>
                            <div class="form-field">
                                <label for="shipper-appointment-required">Appointment Required?</label>
                                <input name="shipper-appointment-required" type="checkbox" formControlName="appointment_shipper">
                            </div>
                        </div>
                        <div class="card-body-section">
                            <h4 class="card-body-section-title">Site Details</h4>
                            <div class="form-field">
                                <label for="shipper-truck-space">Has Truck Space</label>
                                <input name="shipper-truck-space" type="checkbox" formControlName="shipper_truck_space">
                            </div>
                            <div class="form-field">
                                <label for="shipper-loading-dock">Has Loading Dock</label>
                                <input name="shipper-loading-dock" type="checkbox" formControlName="shipper_loading_dock">
                            </div>
                            <div class="form-field">
                                <label for="shipper-tailgate">Require Tailgate</label>
                                <input name="shipper-tailgate" type="checkbox" formControlName="shipper_pickup_tailgate">
                            </div>
                            <div class="form-field">
                                <label for="shipper-straight-truck">Require Straight Truck</label>
                                <input name="shipper-straight-truck" type="checkbox" formControlName="shipper_pickup_straight_truck">
                            </div>
                            <div class="form-field">
                                <label for="shipper-bol-required">Require BOL</label>
                                <input name="shipper-bol-required" type="checkbox" formControlName="shipper_bol_required">
                            </div>
                        </div>
                        <div class="card-body-section">
                            <h4 class="card-body-section-title">Site Type</h4>
                            <div class="form-field">
                                <label for="shipper-residential">Residential</label>
                                <input name="shipper-residential" type="checkbox" formControlName="shipper_is_residential">
                            </div>
                            <div class="form-field">
                                <label for="shipper-commercial">Commercial</label>
                                <input name="shipper-commercial" type="checkbox" formControlName="shipper_is_commercial">
                            </div>
                            <div class="form-field">
                                <label for="shipper-job-site">Job Site</label>
                                <input name="shipper-job-site" type="checkbox" formControlName="shipper_is_job_site">
                            </div>
                            <div class="form-field">
                                <label for="shipper-convention">Convention Center</label>
                                <input name="shipper-convention" type="checkbox" formControlName="shipper_is_convention_center">
                            </div>
                            <div class="form-field">
                                <label for="shipper-popup-store">Pop-up Store</label>
                                <input name="shipper-popup-store" type="checkbox" formControlName="shipper_is_pop_up">
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}" [id]="isDarkMode.checked ? 'consignee-card-dark' : 'consignee-card-light'">
                <div class="card-header">
                    <h2>Consignee</h2>
                </div>
                <div class="card-body">
                    <div class="card-body-section">
                        <form [formGroup]="consignee_form">
                            <h4 class="card-body-section-title">Company</h4>
                            <div class="form-field">
                                <label for="consignee-name">Name</label>
                                <input name="consignee-name" type="text" formControlName="consignee_company_name">
                            </div>
                            <div class="form-field">
                                <label for="consignee-address">Address</label>
                                <input name="consignee-address" type="text" placeholder="Select company name first" formControlName="consignee_company_address">
                            </div>
                                <div class="form-field">
                                    <label for="consignee-appointment-required">Appointment Required?</label>
                                    <input name="consignee-appointment-required" type="checkbox" formControlName="appointment_consignee">
                                </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Site Details</h4>
                        <form [formGroup]="consignee_form">
                            <div class="form-field">
                                <label for="consignee-truck-space">Has Truck Space</label>
                                <input name="consignee-truck-space" type="checkbox" formControlName="consignee_truck_space">
                            </div>
                            <div class="form-field">
                                <label for="consignee-loading-dock">Has Loading Dock</label>
                                <input name="consignee-loading-dock" type="checkbox" formControlName="consignee_loading_dock">
                            </div>
                            <div class="form-field">
                                <label for="consignee-tailgate">Require Tailgate</label>
                                <input name="consignee-tailgate" type="checkbox" formControlName="consignee_pickup_tailgate">
                            </div>
                            <div class="form-field">
                                <label for="consignee-straight-truck">Require Straight Truck</label>
                                <input name="consignee-straight-truck" type="checkbox" formControlName="consignee_pickup_straight_truck">
                            </div>
                            <div class="form-field">
                                <label for="consignee-bol-required">Require BOL</label>
                                <input name="consignee-bol-required" type="checkbox" formControlName="consignee_bol_required">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Site Type</h4>
                        <form [formGroup]="consignee_form">
                            <div class="form-field">
                                <label for="consignee-residential">Residential</label>
                                <input name="consignee-residential" type="checkbox" formControlName="consignee_is_residential">
                            </div>
                            <div class="form-field">
                                <label for="consignee-commercial">Commercial</label>
                                <input name="consignee-commercial" type="checkbox" formControlName="consignee_is_commercial">
                            </div>
                            <div class="form-field">
                                <label for="consignee-job-site">Job Site</label>
                                <input name="consignee-job-site" type="checkbox" formControlName="consignee_is_job_site">
                            </div>
                            <div class="form-field">
                                <label for="consignee-convention">Convention Center</label>
                                <input name="consignee-convention" type="checkbox" formControlName="consignee_is_convention_center">
                            </div>
                            <div class="form-field">
                                <label for="consignee-popup-store">Pop-up Store</label>
                                <input name="consignee-popup-store" type="checkbox" formControlName="consignee_is_pop_up">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}">
                <div class="card-header">
                    <h2>Basic Information</h2>
                </div>
                <div class="card-body">
                    <div class="card-body-section">
                        <form [formGroup]="bill_to_form">
                            <h4 class="card-body-section-title">Third-Party Bill To</h4>
                            <div class="form-field">
                                <label for="3rd-party-bill-to-company">Company Name</label>
                                <input name="3rd-party-bill-to-company" type="text" formControlName="bill_to_company_name">
                            </div>
                            <div class="form-field">
                                <label for="3rd-party-bill-to-address">Company Address</label>
                                <input name="3rd-party-bill-to-address" type="text" placeholder="Select company name first" formControlName="bill_to_company_address">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Transportation Requirements</h4>
                        <div class="card-body-section">
                            <form [formGroup]="transportations_requirements_form">
                                <div class="form-field transport-req">
                                    <label for="CSA">CSA</label>
                                    <input name="CSA" type="checkbox" formControlName="customer_csa">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="FAST">FAST</label>
                                    <input name="FAST" type="checkbox" formControlName="customer_fast">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="ACE">ACE</label>
                                    <input name="ACE" type="checkbox" formControlName="customer_ace">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="ACI">ACI</label>
                                    <input name="ACI" type="checkbox" formControlName="customer_aci">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="CT PAT">CT PAT</label>
                                    <input name="CT_PAT" type="checkbox" formControlName="customer_ct_pat">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="Canada_Bond">Canada Bond</label>
                                    <input name="Canada_Bond" type="checkbox" formControlName="customer_canada_bond">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="US_Bond">US Bond</label>
                                    <input name="US_Bond" type="checkbox" formControlName="customer_us_bond">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="HAZMAT">HAZMAT</label>
                                    <input name="HAZMAT" type="checkbox" formControlName="customer_hazmat">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="protect_from_freezing">Protect from freezing</label>
                                    <input name="protect_from_freezing" type="checkbox" formControlName="customer_hazmat">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="heated">Heated</label>
                                    <input name="heated" type="checkbox" formControlName="customer_heated">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="refrigeration">Refrigeration</label>
                                    <input name="refrigeration" type="checkbox" formControlName="customer_refrigeration">
                                </div>
                                <div class="form-field transport-req">
                                    <label for="food_grade">Food grade</label>
                                    <input name="food_grade" type="checkbox" formControlName="customer_food_grade">
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}">
                <div class="card-header">
                    <h2>Order Type and Scope</h2>
                </div>
                <div class="card-body">
                    <div class="card-body-section">
                        <form [formGroup]="order_type_form">
                            <h4 class="card-body-section-title">Order Type</h4>
                            <div class="form-field">
                                <label for="order-type-usa-domestic">USA Domestic</label>
                                <input name="order-type-usa-domestic" type="checkbox" formControlName="usa_domestic">
                            </div>
                            <div class="form-field">
                                <label for="order-type-canada-domestic">Canada Domestic</label>
                                <input name="order-type-canada-domesti" type="checkbox" formControlName="canada_domestic">
                            </div>
                            <div class="form-field">
                                <label for="order-type-usa-crossborder">USA Crossborder</label>
                                <input name="order-type-usa-crossborder" type="checkbox" formControlName="usa_crossborder">
                            </div>
                            <div class="form-field">
                                <label for="order-type-canada-crossborder">Canada Crossborder</label>
                                <input name="order-type-canada-crossborder" type="checkbox" formControlName="canada_crossborder">
                            </div>
                            <div class="form-field">
                                <label for="order-type-air">Air Freight</label>
                                <input name="order-type-air" type="checkbox" formControlName="air_freight">
                            </div>
                            <div class="form-field">
                                <label for="order-type-ocean">Ocean Freight</label>
                                <input name="order-type-ocean" type="checkbox" formControlName="ocean_freight">
                            </div>
                            <div class="form-field">
                                <label for="order-type-local-delivery">Local Delivery</label>
                                <input name="order-type-local-delivery" type="checkbox" formControlName="local_delivery">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Order Scope</h4>
                        <form [formGroup]="load_form">
                            <select name="order_scope" formControlName="order_scope">
                                <option *ngFor="let scope of ORDER_SCOPE">{{scope}}</option>
                            </select>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Secondary Order Scope</h4>
                        <form [formGroup]="load_form">
                            <select name="order_scope" formControlName="order_scope_secondary">
                                <option *ngFor="let scope of ORDER_SCOPE">{{scope}}</option>
                            </select>
                        </form>
                    </div>
                </div>
            </div>
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}">
                <div class="card-header">
                    <h2>Pallets</h2>
                </div>
                <div class="card-body">
                    <div *ngFor="let p of pallet_set; let i = index" class="pallet">
                        <form [formGroup]="p">
                            <label>
                                Pallet
                                <input required type="radio" value="pallet" formControlName="pallet_or_product">
                            </label>
                            <label>
                                Product
                                <input type="radio" value="product" formControlName="pallet_or_product">
                            </label>
                            <br>
                            <label *ngIf="p.get('pallet_or_product')?.value === 'product'">
                                Model Number
                                <input type="text" formControlName="model_num">
                            </label>
                            <label *ngIf="p.get('pallet_or_product')?.value === 'pallet'">
                                Pallet Quantity
                                <input class="pallet-number-field" type="text" formControlName="pallet_qty">
                            </label>
                            <br>
                            <label *ngIf="p.get('pallet_or_product')?.value !== ''">
                                Width
                                <input required class="pallet-number-field" type="number" formControlName="width">
                            </label>
                            <label *ngIf="p.get('pallet_or_product')?.value !== ''">
                                Length
                                <input required class="pallet-number-field" type="number" formControlName="length">
                            </label>
                            <label *ngIf="p.get('pallet_or_product')?.value !== ''">
                                Height
                                <input required class="pallet-number-field" type="number" formControlName="height">
                            </label>
                            <label *ngIf="p.get('pallet_or_product')?.value !== ''">
                                Weight
                                <input required class="pallet-number-field" type="number" formControlName="weight">
                            </label>
                            <br>
                            <label *ngIf="p.get('pallet_or_product')?.value === 'product'">
                                Description
                                <input type="text" formControlName="description">
                                <br>
                            </label>
                            <button (click)="removePallet(i)">Remove</button>
                        </form>
                    </div>
                    <button (click)="addPallet()">+</button>
                </div>
                
            </div>
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}">
                <div class="card-header">
                    <h2>Load Information</h2>
                </div>
                <div class="card-body" id="load-info-card-body">
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Equipment</h4>
                        <form [formGroup]="load_form">
                            <div class="form-field">
                                <label for="equipment_type">Equipment Type</label>
                                <select name="equipment_type" formControlName="type_of_equipment">
                                    <option *ngFor="let type of EQUIPMENT_TYPES" value="{{type}}">{{type}}</option>
                                </select>
                            </div>
                            <div class="form-field">
                                <label for="equipment_options">Equipment Options</label>
                                <select name="equipment_options" formControlName="equipment_options">
                                    <option *ngFor="let option of EQUIPMENT_OPTIONS" value="{{option}}">{{option}}</option>
                                </select>
                            </div>
                            <div class="form-field">
                                <label for="partial">Partial</label>
                                <input id="partial" type="radio" value="partial" formControlName="partial_or_full">
                            </div>
                            <div class="form-field">
                                <label for="full">Full</label>
                                <input id="full" type="radio" value="full" formControlName="partial_or_full">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <form [formGroup]="packaging_types_form">
                            <h4 class="card-body-section-title">Packaging Type</h4>
                            <div class="form-field">
                                <label for="packaging-type-palleted">Palleted</label>
                                <input name="packaging-type-palleted" type="checkbox" formControlName="palleted">
                            </div>
                            <div class="form-field">
                                <label for="packaging-type-carton">Carton</label>
                                <input name="packaging-type-carton" type="checkbox" formControlName="carton">
                            </div>
                            <div class="form-field">
                                <label for="packaging-type-crate">Crate</label>
                                <input name="packaging-type-crate" type="checkbox" formControlName="crate">
                            </div>
                            <div class="form-field">
                                <label for="packaging-type-loose-floor">Loose / Floor</label>
                                <input name="packaging-type-loose-floor" type="checkbox" formControlName="loose_floor">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <form [formGroup]="load_form">
                            <div class="form-field">
                                <label for="product_status">Product Status</label>
                                <label>
                                    New
                                    <input type="radio" value="new" name="product_status" formControlName="product_status" checked>
                                </label>
                                <label>
                                    Used
                                    <input type="radio" value="used" name="product_status" formControlName="product_status">
                                </label>
                            </div>
                            <div class="form-field">
                                <label for="booking_number">Booking Number</label>
                                <input name="booking_number" type="text" formControlName="booking_number" placeholder="Booking Number">
                            </div>
                            <div class="form-field">
                                <label for="release_number">Release Number</label>
                                <input name="release_number" type="text" formControlName="release_number" placeholder="Release Number">
                            </div>
                            <div class="form-field">
                                <label for="lading_number">Bill of Lading Number</label>
                                <input name="lading_number" type="text" formControlName="lading_number" placeholder="Bill of Lading Number">
                            </div>
                            <div class="form-field">
                                <label for="trip_number">Trip Number</label>
                                <input name="trip_number" type="text" formControlName="trip_number" placeholder="Trip Number">
                            </div>
                            <div class="form-field">
                                <label for="shipment_number">Shipment Number</label>
                                <input name="shipment_number" type="text" formControlName="shipment_number" placeholder="Shipment Number">
                            </div>
                            <div class="form-field">
                                <label for="requirements">Requirements</label>
                                <input name="requirements" type="text" formControlName="requirements" placeholder="Requirements">
                            </div>
                            <div class="form-field">
                                <label for="total_length">Load Length (feet)</label>
                                <input name="total_length" type="text" formControlName="total_length" placeholder="Load Length">
                            </div>
                            <div class="form-field">
                                <label>Load Value Unit</label>
                                <select formControlName="load_value_unit">
                                    <option value="USD">USD</option>
                                    <option value="CND">CND</option>
                                    <option value="OTHER">OTHER</option>
                                </select>
                            </div>
                            <div class="form-field">
                                <label for="load_value">Load Value</label>
                                <input name="load_value" type="text" formControlName="load_value" placeholder="Load Value">
                            </div>
                            <div class="form-field">
                                <button (click)="loadInfoDialog.show()">Click to Add Details/Special Info</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}">
                <div class="card-header">
                    <h2>Operations</h2>
                </div>
                <div class="card-body">
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Pickup</h4>
                        <form [formGroup]="pickup_delivery_form">
                            <div class="form-field">
                                <label>Pickup Reference</label>
                                <input formControlName="shipper_pickup_reference" type="text" size="10">
                            </div>
                            <div class="form-field">
                                <label>Estimated Pickup Date</label>
                                <input formControlName="appointment_date_shipper" type="date">
                            </div>
                            <div class="form-field">
                                <label>Estimated Pickup Time Start</label>
                                <input formControlName="appointment_time_start_shipper" type="time">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Delivery</h4>
                        <form [formGroup]="pickup_delivery_form">
                            <div class="form-field">
                                <label>Delivery Reference</label>
                                <input formControlName="consignee_delivery_reference" type="text" size="10">
                            </div>
                            <div class="form-field">
                                <label>Estimated Delivery Date</label>
                                <input formControlName="appointment_date_consignee" type="date">
                            </div>
                            <div class="form-field">
                                <label>Estimated Delivery Time Start</label>
                                <input formControlName="appointment_time_start_consignee" type="time">
                            </div>
                        </form>
                    </div>
                    <div class="card-body-section">
                        <h4 class="card-body-section-title">Operations</h4>
                        <form [formGroup]="ops_form">
                            <div class="form-field">
                                <label>Carrier Rated</label>
                                <input formControlName="carrier_rated" type="checkbox">
                            </div>
                            <div class="form-field">
                                <label>Carrier Re-Rated</label>
                                <input formControlName="carrier_rerated" type="checkbox">
                            </div>
                            <div class="form-field">
                                <label>Straps and Bars</label>
                                <input formControlName="straps_bars" type="checkbox">
                            </div>
                            <div class="form-field">
                                <label>Protective Equipment</label>
                                <input formControlName="protective_equipment" type="checkbox">
                            </div>
                            <div class="form-field">
                                <button (click)="opsNotationDialog.show()">Add Notation</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div [ngClass]="{'card-dark': isDarkMode.checked, 'card-light': !isDarkMode.checked}" [id]="isDarkMode.checked ? 'rate-card-dark' : 'rate-card-light'">
                <div class="card-header">
                    <h2>Rate</h2>
                </div>
                <div class="card-body">
                    <div class="card-body-section">
                        <div class="form-field">
                            <label for="rate-method">Rate Method</label>
                            <select name="rate-method">
                                <option value="cubic feet">Cubic Feet</option>
                                <option value="weight">Weight</option>
                                <option value="linear feet">Linear Feet</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</div>